/**
 * pack-switcher.js
 * Fast AJAX pack switching — shares cache with product-switcher.js
 * via window.__switcherState. Works standalone if product-switcher
 * is not present on the page.
 */
(function () {
  'use strict';

  /* ── Shared state (shared with product-switcher.js) ── */
  if (!window.__switcherState) {
    window.__switcherState = {
      cache: {},
      fetching: {},
      version: 0
    };
  }
  var S = window.__switcherState;
  var CACHE_TTL = 5 * 60 * 1000;

  /* ── Fetch + cache ── */

  function fetchPage(url, priority) {
    if (S.cache[url] && (Date.now() - S.cache[url].timestamp < CACHE_TTL)) {
      return Promise.resolve(S.cache[url]);
    }
    if (S.fetching[url]) return S.fetching[url].then(function () { return S.cache[url]; });

    var opts = { credentials: 'same-origin', headers: { 'Accept': 'text/html' } };
    if (priority) opts.priority = priority;

    var p = fetch(url, opts)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        S.cache[url] = { html: html, doc: doc, title: doc.title, timestamp: Date.now() };
        delete S.fetching[url];
        preloadHeroImage(doc);
        return S.cache[url];
      })
      .catch(function (e) {
        delete S.fetching[url];
        throw e;
      });

    S.fetching[url] = p;
    return p;
  }

  /* ── Preload hero image ── */

  function preloadHeroImage(doc) {
    var img = doc.querySelector('.sec__main-product .product__media img')
           || doc.querySelector('.sec__main-product img')
           || doc.querySelector('#MainContent img');
    if (!img) return;
    var src = img.getAttribute('src') || img.getAttribute('srcset');
    if (!src) return;
    if (src.indexOf(',') !== -1) src = src.split(',')[0].split(' ')[0];
    var preload = new Image();
    preload.src = src.trim();
  }

  /* ── Activate scripts after swap ── */

  function activateScripts(container) {
    var scripts = container.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var old = scripts[i];
      if (old.type === 'application/json' || old.type === 'application/ld+json'
          || old.type === 'importmap') continue;
      var clone = document.createElement('script');
      for (var a = 0; a < old.attributes.length; a++) {
        clone.setAttribute(old.attributes[a].name, old.attributes[a].value);
      }
      if (old.textContent) clone.textContent = old.textContent;
      old.parentNode.replaceChild(clone, old);
    }
  }

  /* ── Hoist stylesheets ── */

  function hoistStylesheets(newMainEl) {
    var links = newMainEl.querySelectorAll('link[rel="stylesheet"]');
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      if (href && !document.querySelector('head link[href="' + CSS.escape(href) + '"]')) {
        document.head.appendChild(link.cloneNode(true));
      }
    });
  }

  /* ── Post-swap: re-init gallery, lazy images, and Swiper ── */

  function postSwapInit(container) {
    requestAnimationFrame(function () {
      // Grid gallery thumbnail — fix BEFORE grid gallery init
      var gridThumb = container.querySelector('grid-gallery-thumbnail');
      if (gridThumb) {
        gridThumb.actionScroll = gridThumb.querySelectorAll('.action-grid-item');
        gridThumb.MediaGalleryThumbnailHtml = gridThumb.innerHTML;
      }

      // Grid gallery — restore saved HTML, then re-init
      var gridGallery = container.querySelector('grid-gallery');
      if (gridGallery) {
        gridGallery.MediaGalleryHtml = gridGallery.innerHTML;
        try { gridGallery.init(); } catch (e) {}
      }

      // Media gallery — Swiper for thumbnail layout + Drift zoom
      var gallery = container.querySelector('media-gallery');
      if (gallery && typeof gallery.init === 'function') {
        try { gallery.init(); } catch (e) {}
      }

      // Force-load all remaining lazy images
      container.querySelectorAll('.image-lazy-load').forEach(function (img) {
        var picture = img.closest('picture');
        if (picture) {
          var source = picture.querySelector('source');
          if (source && source.dataset.srcset) {
            source.setAttribute('srcset', source.dataset.srcset);
            source.removeAttribute('data-srcset');
          }
        }
        if (img.dataset.srcset) {
          img.setAttribute('srcset', img.dataset.srcset);
          img.removeAttribute('data-srcset');
          img.classList.remove('image-lazy-load');
          img.classList.add('lazy-loaded');
        }
      });

      // Clear loading state on motion-effect wrappers
      container.querySelectorAll('motion-effect.loading').forEach(function (el) {
        el.classList.remove('loading');
        el.classList.add('loaded');
      });
    });
  }

  /* ── AJAX navigation ── */

  function navigateTo(url, clickedEl) {
    S.version++;
    var myVersion = S.version;

    if (clickedEl) {
      var loadingClass = clickedEl.closest('.pack-switcher')
        ? 'pack-switcher__link--loading'
        : 'product-switcher__pill--loading';
      clickedEl.classList.add(loadingClass);
    }

    var currentMain = document.querySelector('#MainContent');
    if (currentMain) currentMain.style.opacity = '0.4';

    var progressBar = document.querySelector('progress-bar-load');
    if (progressBar && typeof progressBar.complete === 'function') {
      progressBar.complete();
    }

    return fetchPage(url)
      .then(function (cached) {
        if (myVersion !== S.version) return;
        if (!cached || !cached.doc) throw new Error('empty');

        var newMain = cached.doc.querySelector('#MainContent');
        if (!newMain || !currentMain) throw new Error('no MainContent');

        hoistStylesheets(newMain);

        currentMain.style.opacity = '';
        currentMain.innerHTML = newMain.innerHTML;
        activateScripts(currentMain);

        // Re-init gallery, lazy images, and Swiper
        postSwapInit(currentMain);

        document.title = cached.title;
        history.pushState({ _ps: true, url: url }, '', url);

        var section = document.querySelector('.sec__main-product')
                   || document.querySelector('#MainContent');
        if (section) {
          var rect = section.getBoundingClientRect();
          var offset = window.pageYOffset + rect.top - 10;
          window.scrollTo({ top: Math.max(0, offset), behavior: 'instant' });
        }

        if (progressBar) {
          progressBar.style.display = 'none';
          var ind = progressBar.querySelector('.indeterminate');
          if (ind) { ind.style.width = '0%'; ind.style.opacity = '1'; }
        }

        initPackSwitcher();

        try {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('page_viewed');
          }
        } catch (e) {}

        document.dispatchEvent(new CustomEvent('product-switcher:navigated', {
          detail: { url: url }
        }));
      })
      .catch(function () {
        if (myVersion !== S.version) return;
        window.location = url;
      });
  }

  /* ── Collect pack-switcher URLs ── */

  function getPackUrls() {
    var urls = [];
    document.querySelectorAll('.pack-switcher__link[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href && urls.indexOf(href) === -1) urls.push(href);
    });
    return urls;
  }

  /* ── Init: bind events on pack switcher ── */

  function initPackSwitcher() {
    var switcher = document.querySelector('.pack-switcher');
    if (!switcher) return;

    switcher.addEventListener('click', function (e) {
      var link = e.target.closest('.pack-switcher__link[href]');
      if (!link) return;
      e.preventDefault();
      navigateTo(link.getAttribute('href'), link);
    });

    switcher.addEventListener('mouseover', function (e) {
      var link = e.target.closest('.pack-switcher__link[href]');
      if (link) fetchPage(link.getAttribute('href'), 'high');
    });

    switcher.addEventListener('focusin', function (e) {
      var link = e.target.closest('.pack-switcher__link[href]');
      if (link) fetchPage(link.getAttribute('href'), 'high');
    });
  }

  /* ── Background prefetch ── */

  function backgroundPrefetch() {
    var urls = getPackUrls();
    if (urls.length === 0) return;
    var delay = 0;
    urls.forEach(function (url) {
      delay += 200;
      setTimeout(function () { fetchPage(url, 'low'); }, delay);
    });
  }

  /* ── Popstate (register only once, shared flag) ── */

  if (!S.popstateBound) {
    S.popstateBound = true;
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state._ps) {
        navigateTo(location.href, null);
      } else if (document.querySelector('.pack-switcher') || document.querySelector('.product-switcher')) {
        location.reload();
      }
    });
  }

  /* ── Boot ── */

  function boot() {
    initPackSwitcher();

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { backgroundPrefetch(); }, { timeout: 3000 });
    } else {
      setTimeout(backgroundPrefetch, 2000);
    }

    if (!history.state || !history.state._ps) {
      history.replaceState({ _ps: true, url: location.href }, '', location.href);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
